/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I run more than one stopwatch at once?`)
};

const es_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo usar más de un cronómetro a la vez?`)
};

const de_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich mehr als eine Stoppuhr gleichzeitig laufen lassen?`)
};

const nl_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik meer dan één stopwatch tegelijk gebruiken?`)
};

const fr_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je faire fonctionner plusieurs chronomètres en même temps ?`)
};

const it_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso far funzionare più di un cronometro contemporaneamente?`)
};

const pt_br2_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso rodar mais de um cronômetro ao mesmo tempo?`)
};

const pt_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso ter mais do que um cronómetro em execução ao mesmo tempo?`)
};

const ja_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数のストップウォッチを同時に使えますか？`)
};

const zh_timer_stopwatch_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以同时运行多个秒表吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_faq4_q", locale)
	if (locale === "en") return en_timer_stopwatch_faq4_q(inputs)
	if (locale === "es") return es_timer_stopwatch_faq4_q(inputs)
	if (locale === "de") return de_timer_stopwatch_faq4_q(inputs)
	if (locale === "nl") return nl_timer_stopwatch_faq4_q(inputs)
	if (locale === "fr") return fr_timer_stopwatch_faq4_q(inputs)
	if (locale === "it") return it_timer_stopwatch_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_faq4_q(inputs)
	if (locale === "pt") return pt_timer_stopwatch_faq4_q(inputs)
	if (locale === "ja") return ja_timer_stopwatch_faq4_q(inputs)
	return zh_timer_stopwatch_faq4_q(inputs)
};